module.exports = __webpack_public_path__ + "static/media/pm_footer_image.8be95626.svg";